export default "__VITE_ASSET__ecb9eaa9__"